// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2UhdK","header":"ReportDetails_header__1IS_8","title":"ReportDetails_title__Fznyh","left":"ReportDetails_left__2vvu7"};